import { SanityHeroTextColor } from './types';

export const getColorForSanityHeroTextColor = (
  sanityColor: string | null,
  defaultColor: string
) => {
  if (!sanityColor) {
    return defaultColor;
  }

  return sanityColor === SanityHeroTextColor.White ? Styles.color.white : Styles.color.black;
};
